export const RoutePath = {
  authError: '/auth-error',
  consentConfirmation: '/consentConfirmation',
  eligibleVehicle: '/eligiblevehicle',
  error: '/error',
  login: '/consent',
  logout: '/logout',
  root: '/',
  version: '/version',
  log: '/log',
};
